import { render, staticRenderFns } from "./QuestionAndAnswer.vue?vue&type=template&id=7080840a&scoped=true"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
import style0 from "./QuestionAndAnswer.vue?vue&type=style&index=0&id=7080840a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7080840a",
  null
  
)

export default component.exports